// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Datu centrs",
        "pull_refresh": "Novelciet uz leju, lai atsvaidzinātu",
        "release_refresh": "Atlaidiet, lai atsvaidzinātu",
        "refresh_loading": "Iekraušana ...",
        "footer_text": "Pakalpojumi nodrošina Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Meklēt valsti/reģionu",
        "my_flow": "Mani dati",
        "charge_code": "Kupona kods",
        "coupons": "Kuponi",
        "local_package": "Vietējie dati",
        "more": "Vairāk",
        "popular_destination": "Valsts/reģions",
        "buy_now": "Pirkt tūlīt",
        "package_useing": "Aktīvs",
        "unused": "Neaktīvs",
        "download_app": "Lejupielādēt lietotni",
        "enter_the_mall_list": "Ieeja tirdzniecības centrā",
        "no_data": "Vēl nav datu",
        "no_data_available": "Dati nav pieejami",
        "copy_success": "Kopēts veiksmīgi",
        "copy_fail": "Kopēšana neizdevās",
        "meritsTitle": "Kādi ir priekšrocības?",
        "merits1": "Bez SIM kartes & Bez mēnešnieku maksām",
        "merits2": "Integrēts ar top 2-3 operatoriem automātiskai tīkla pārliekšanai",
        "go_buy": "Iegādāties tagad",
        "instant_savings": "Ietaupi",
        "expires_in": "Beidzas pēc",
        "download_app_tips": "Lejupielādējiet lietotni, lai iegūtu vairāk piedāvājumus un pieredzes"
    },
    "packages": {
        "sub_title": {
            "us": "Izņemot Guamu, Saipan",
            "it": "Ieskaitot Vatikāna pilsētu, Sanmarino",
            "va": "Ieskaitot Itāliju, Sanmarino",
            "sm": "Ieskaitot Itāliju, Vatikāna pilsētu",
            "ma": "Ieskaitot Rietumahāras",
            "eh": "Ieskaitot Maroku",
            "ch": "Ieskaitot Lihtenšteinu",
            "li": "Ieskaitot Šveici",
            "fr": "Ieskaitot Monako",
            "mc": "Ieskaitot Franciju",
            "fi": "Ieskaitot Alandas salas",
            "ax": "Ieskaitot Somiju",
            "gu": "Ieskaitot Ziemeļmarianas salas",
            "mp": "Ieskaitot Guamu"
        },
        "unlimited_packages": "Neierobežota datu pakete",
        "normal_packages": "Parastā datu pakete",
        "multi_region_packages": "Multi-reģions",
        "regional_data": "Regiona dati",
        "high_speed_text": "ātrgaitas dati",
        "infiniteFlow": "Neierobežoti dati",
        "unLimitData": "Bezgalīgs",
        "high_speed_text_year": "ātrgaitas/MP",
        "package_list": "Iepakojuma saraksts",
        "special_offer": "Akcijas",
        "first_month": "1. Mēnesis",
        "periodUnit": {
            "day": "Diena (-as)",
            "month": "mēnesis",
            "hour": "stunda (-as)",
            "year": "gads"
        },
        "periodUnits": {
            "day": "Diena (-as)",
            "month": "mēneši",
            "hour": "stunda (-as)",
            "year": "gadi"
        },
        "periodUnitSimp": {
            "day": "s",
            "month": "par",
            "hour": "h",
            "year": "līdz"
        },
        "periodUnitMonthly":"Mēnešīgs",
        "periodUnitsSimp": {
            "day": "s",
            "month": "par",
            "hour": "h",
            "year": "līdz"
        },
        "unlimited_good_name": {
            "day": "Dienas caurlaide",
            "month": "Ikmēneša caurlaide",
            "year": "Gada caurlaide"
        },
        "continuousMonth": "Nepārtraukti mēneši",
        "continuousDay": "Nepārtrauktas dienas",
        "continuousYear": "Nepārtraukti gadi",
        "day_invalid": "Derīguma termiņš pašreizējā dienā",
        "month_invalid": "Beidzas pašreizējā mēnesī",
        "immediate_valid": "Stājas spēkā nekavējoties",
        "tomorrow_day_valid": "Stājas spēkā no nākamās dienas",
        "tomorrow_month_valid": "Stājas spēkā no nākamā mēneša",
        "detail": {
            "cell_flow": "Dati",
            "cell_period": "Derīgums",
            "buy_quantity": "Summa",
            "use_area": "Pārklājums",
            "use_intro": "Noteikumi un nosacījumi",
            "buy_btn": "Pasūtīt",
            "pay": "Samaksāt",
            "buy_tips": "Jums ir %@packageName pakets izmantojamas. Vai jūs vēlaties nopirkt šo paketu?",
            "haveOrderTips": "Izveidota pasūtījuma ar gaidītu maksājumu. Noklikšķiniet Apstiprināt, lai pārvietotos uz manu datu lapu！"
        },
        "confirm": {
            "title": "Pasūtījuma apstiprinājums",
            "real_pay_amount": "Maksātā summa",
            "online_payment": "Tiešsaistes maksājums",
            "create_order_error": "Iestatīšana neizdevās"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Pasūtījuma statusa iegūšana ...",
            "buy_success": "Pasūtīt pabeigt",
            "buy_pending": "Gaidīts apstiprinājums",
            "buy_pending_tip": "Maksājums procesā… ja maksājums netika pārsūtīts 10 minūšu laikā, lūdzu, sazinieties ar mums, lai saņemtu atbalstu.",
            "get_payment_info_fail": "Maksājumu informācijas iegāde neizdevās",
            "cell_package": "Iesaiņojums",
            "cell_buy_amount": "Zems",
            "cell_real_amount": "Maksātā summa",
            "go_to_order_btn": "Dodieties uz manu paketi",
            "back_home": "Atpakaļ uz mājām",
            "back_mall": "Atpakaļ uz tirdzniecības centru",
            "ordersn_empty": "Pasūtīt SN nevar būt tukšs",
            "order_search_error": "Negaidīta kļūda",
            "goodsName": 'Produkta nosaukums'
        },
        "fail": {
            "payment_fail": "Maksājums neizdevās",
            "back_home": "Atpakaļ uz mājām"
        }
    },
    "CountryGroup": {
        "title": "Valsts/reģions",
        "placeholder": "Meklēt valsti vai reģionu",
        "clear": "Noskaidrot",
        "history": "Meklēšanas vēsture"
    },
    "PromotionCode": {
        "verification": {
            "title": "Kupona kods",
            "minititle": "Kupona kods",
            "input": "Lūdzu, ievadiet papildinājuma kodu",
            "explain": "Padomi: Pieskarieties skenēšanas pogai augšējā labajā pusē, lai skenētu kupona kartes QR kodu, vai manuāli ievadiet kupona kodu (Case jutīgs), ja tas nedarbojas.",
            "submit": "Iesniegt",
            "exchange": "Izpirkt",
            "cancel": "Atcelt",
            "Inquiry": "Vai esat pārliecināts, ka apmainīsities",
            "ErrorCode": "Uzlādēšanas koda kļūda"
        },
        "recharge_success": {
            "package": "Iesaiņojums",
            "content": "Veiksmīgi izpirkts",
            "back": "Atpakaļ uz iepirkšanās centru",
            "view_packets": "Dodieties uz manu paketi"
        }
    },
    "order": {
        "state": {
            "inUse": "Aktivizēts",
            "isFirst": "Prioritāte",
            "toFirst": "Noteikt prioritāti",
            "inactive": "Nenovirzīts"
        },
        "periodUnits": {
            "minute": "minūte (-as)",
            "hour": "stunda (-as)",
            "day": "Diena (-as)",
            "month": "mēnesis (-i)"
        },
        "useIntro": {
            "tip1": "Neierobežotai datu pakotnei ir augstāka prioritāte nekā apjoma datu paketē.",
            "tip2": "Lietošanas prioritāte tiks balstīta uz tāda paša veida paketes pirkšanas datumu, t.i., vispirms tiks izmantota pakete ar agrāko pirkuma datumu, savukārt viena reģiona pakešu prioritāte ir augstāka nekā reģionālā pakete.",
            "tip3": "Varat arī manuāli pielāgot tāda paša veida pakešu izmantošanas prioritāti."
        },
        "myFlow": "Mani dati",
        "remainingFlow": "Dati",
        "remainingTime": "Derīgs kreisais",
        "remainingHighFlow": "Palikušas ātrgaitas dati",
        "validPeriod": "Derīgums",
        "noneFlow": "Nav datu paketes",
        "noneFlowTip": "Lūdzu, iegādājieties datu paketi un izbaudiet augstas kvalitātes tīklu",
        "buyPackFlow": "Iepirkt paketes",
        "checkInvalidFlow": "Pārbaudiet datu paketi, kuru beidzas derīguma termiņš",
        "orderList": {
            "title": "mani pasūtījumi",
            "amount_paid": "Kopā",
            "device": "Īpašumā esošā ierīce",
            "order_details": "Pasūtījuma informācija",
            "total_amont": "Starpsumma",
            "orderSN": "Pasūtījuma Nr.",
            "createTime": "Radīšanas laiks",
            "cancelTime": "Slēgts laiks",
            "payTime": "Pasūtījuma laiks",
            "unsubTime": "Atcelts laiks",
            "payMethod": "Maksājuma veids",
            "thirdSN": "Darījuma Nr.",
            "delete": "Dzēst",
            "cancel": "Atcelt pasūtījumu",
            "unsub": "Atmaksa",
            "goto_cancel": "Vai vēlaties atcelt pasūtījumu?",
            "goto_unsubscribe": "Vai vēlaties anulēt pasūtījuma abonēšanu?",
            "delete_Tips": "Pasūtījumu pēc dzēšanas nevar atsākt, tāpēc jūsu pēcapkalpošanas problēmas nevar tikt galā.Vai tiešām to izdzēsīsiet?",
            "status_success": "Pabeigts",
            "status_pending": "Neapmaksāts",
            "status_cancel": "Slēgts",
            "status_unsub": "Atcelts",
            "payMethod_stripe": "Kreditkarte"
          },
    },
    "registerlogin": {
        "create_account_tip":"Įrenginys Naudokite šalį/regioną",
        "select_country_tip":"Ierīces lietošana valstī/reģionā",
        "email_name": "Sūtīt pa pastu",
        "phone_name": "Telefons",
        "email_address": "E -pasta adrese",
        "password": "parole",
        "country": "apvidus",
        "select_country": "Izvēlieties valsti",
        "cancel": "Atcelt",
        "confirm": "Drošs",
        "please_enter": "Lūdzu, ievadiet 6-20 rakstzīmes (burtu, ciparu vai simbolu kombinācija)",
        "select_country_tips": "Valsts izvēle ir paredzēta vietējo pakešu skatīšanai. Pēc reģistrācijas to nevar mainīt. Lūdzu, apstipriniet!",
        "global_roaming": "Starptautiskais domēna kods",
        "phone_number": "tālruņa numurs",
        "agree": "saskaņot",
        "user_agreement": "Lietotāju līgums",
        "and": "un",
        "privacy_policy": "Konfidencialitātes politika",
        "register_login": "Reģistrējieties vai piesakieties",
        "login_error": "Pieteikšanās skaits ir pārāk biežs, lūdzu, mēģiniet vēlreiz vēlāk!",
        "register_error": "Reģistrāciju skaits ir pārāk biežs, lūdzu, mēģiniet vēlreiz vēlāk!",
        "forgot_pwd": "Aizmirstiet paroli",
        "app_tips": "Piesakieties lietotnē ar šo kontu pēc lejupielādes, lai piekļūtu vairāk funkciju.",
        "download_app": "Dodieties lejupielādēt lietotni",
        "rememberPwd": "Atcerieties paroli",
        "third_login": "Turpināt",
        "agreement_tips": "Lūdzu, pārbaudiet lietotāja līguma un privātuma politikas lodziņu",
        "selectCountry_tips": "Lūdzu, lūdzu, ņemiet vērā, ka reģistrētā valsts tieši ietekmēs šādas maksājuma metodes un valūtas, lūdzu, atlasiet atbilstoši savām vajadzībām.",
        "login_error_cancel": "Lietotājs atcēla pieslēgšanos",
        "login_error_auth": "Atļaujiet pop-up logus no pārlūkprogrammas iestatījumiem",
        "device_tips": "Ierīce gaida aktivēšanu. Apstrāde 24 stundu laikā."
    },
    "forgotPwd": {
        "forgot_pwd": "Aizmirstiet paroli",
        "email_address": "E -pasta adrese",
        "next": "Blakus",
        "email_has_been_sent": "Mēs esam nosūtījuši e -pastu uz %@email. Lūdzu, noklikšķiniet uz saites un veiciet darbības, lai iegūtu paroli.",
        "have_retrieved_it": "Esmu to atradis",
        "unable_to_receive_email": "Vai nevarat saņemt e -pastu? Lūdzu, pārbaudiet, vai ir e -pasts no %@email zem surogātpasta, un izdzēstā pasta direktorija",
        "or": "vai",
        "resend": "Nokārtot",
        "global_roaming": "Starptautiskais domēna kods",
        "phone_number": "tālruņa numurs",
        "verification_code_has_been_sent": "Mēs esam nosūtījuši verifikācijas kodu uz:",
        "verification_code": "Verifikācijas kods",
        "no_verification_code_received": "Vai nesaņēmāt verifikācijas kodu?",
        "please_enter": "Lūdzu, ievadiet 6-20 rakstzīmes (burtu, ciparu vai simbolu kombinācija)",
        "reset_password": "Atiestatīt paroli",
        "reset_successful": "Veiksmīgi atiestatīt"
    },
    "coupons": {
        "coupons_name": "Kuponi",
        "no_coupons": "Pagaidām nav kuponu",
        "no_data": "Vēl nav datu",
        "applicable_to_the_following": "Kuponi ir piemēroti šādai datu pakotnei"
    },
    "digital":{
        "title":"Ierīce SN",
        "purchased":"Mani pirkumi",
        "viewAll":"Vairāk",
        "skinStore":"Produktu veikals",
        "completed":"Nopirkts",
        "goBuy":"Iegādāties",
        "order": {
          "title":"Nopirktie pasūtījumi"
        },
        "detail": {
          "describe":"Apraksts"
        }
    },
    "viewPL": {
        "other": 'citi'
    },
    "invalidFlow": {
        "stateName": "Statuss",
        "state": {
            "NOT_ACTIVATED": "Nenovirzīts",
            "IN_USING": "Pieejams",
            "USE_END": "Izsmelts",
            "EXPIRE": "Beidzies",
            "TRANSFER": "Nodot",
            "UNSUBSCRIBE": "Atcelt",
            "VALID": "Derīgs",
            "INVALID": "Nederīgs",
            "EXCHANGE_POINTS": "Izpirkt punktus"
        },
        "noneFlow": "Nav datu paketes, kurai beidzies derīguma termiņš",
        "pageName": "Datu pakete, kurai beidzies derīguma termiņš"
    },
    "flowDetail": {
        "title": "Dati par datiem",
        "flow": "Dati",
        "validTime": "Derīgs sākums",
        "invalidTime": "Derīgs līdz",
        "coverage": "Pārklājums",
        "useIntro": "Noteikumi un nosacījumi",
        "purchaseTime": "Nopirkts plkst",
        "subtotal": "Zems",
        "status": "Statuss",
        "cancel": "Atcelt",
        "buyAgain": "Pērciet to vēlreiz",
        "validity": "Derīgums",
        "tip": "Pamanīt",
        "cancelTip": "Vai esat pārliecināts, ka vēlaties atmaksāt šo paketi?",
        "dataLeft": "Dati"
    },
    "netError": {
        "try_again": "Mēģiniet vēlreiz",
        "net_error": "Nav tīkla",
        "try_again_desc": "Lūdzu, pārbaudiet tīkla iestatījumu un mēģiniet vēlreiz"
    },
    "loadFail": {
        "try_again": "Mēģiniet vēlreiz",
        "load_fail": "Ielādēšana neizdevās",
        "load_fail_desc": "Datu ielāde neizdevās, lūdzu, mēģiniet vēlreiz",
        "IMEI_Not_Exist": "IMEI nepastāv, lūdzu, mēģiniet iekļūt no labās ieejas",
        "Project_Not_Exist": "Rodas kļūda. Lūdzu, sazinieties ar klientu apkalpošanu. (01)",
        "commonError": "Rodas kļūda. Lūdzu, sazinieties ar klientu apkalpošanu."
    },
    "settlement_Easy_and_convenient": "Viegli un ērti",
    "settlement_Great_deal": "Liels darījums",
    "settlement_Safe_and_secure": "Drošs un drošs",
    "settlement_Autopay_service_regulation": "Autopay pakalpojumu regulēšana",
    "settlement_Read": "Lasīt",
    "settlement_No_coupon": "Nav pieejams kupons",
    "settlement_Subtotal": "Zems",
    "settlement_Coupon": "Kupons",
    "settlement_TOTAL": "Kopsumma",
    "settlement_promotion_tip": "Reklāmas piedāvājumu nevar izmantot kopā ar jebkuru kuponu",
    "settlement_coupon_tip": "Kuponu nevar izmantot kopā ar citiem reklāmas piedāvājumiem",
    "member_myFlow_noList": "Nav datu~",
    "detail_se_content": "Drošs, ērts un ērts veids. Jūs varat abonēt jebkurā laikā",
    "Enter_Promo_code": "Veicināšanas kods",
    "Enter_Promo_Coupon": "Kuponi",
    "settlement_Not_used_coupon": "kupons netiek izmantots",
    "settlement_Available_coupon": "Pieejams",
    "settlement_Unavailable_coupon": "Nepieejams",
    "please_Enter_Promo_code": "Lūdzu, ievadiet reklāmas kodu",
    "please_Select_Coupon_use": "Lūdzu, atlasiet kuponu, kuru vēlaties izmantot.",
    "Buy_Now": "Pirkt tūlīt",
    "Dont_Use_Any": "Nelietojiet nevienu",
    "settlement_confirm": "Apstiprināt",
    "settlement_tips": "Apstiprināt",
    "flowDetail_unsubscribe": "Abonēt",
    "flowDetail_unsubscribed": "Abonēts",
    "flowDetail_isCancelPackage": "Atteikt šo paketi?",
    "flowDetail_confirmAgreementUnsubscribe": "Pēc abonēšanas jums nevar būt daudz. Vai esat pārliecināts, ka vēlaties abonēt?",
    "flowDetail_cancel": "Atcelt",
    "flowDetail_cancelSuccess": "Veiksmīgi atiestatīt",
    "packages_detail_promotion": "Reklama",
    "orderTips":{
        "iDay" : "diena",
        "iDays" : "dienas",
        "iMonth" : "mēnesis",
        "iMonths" : "mēneši",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol par jūsu pirmo pirkumu, Maksājiet %@money/%@periodSymbol vēlāk, Jūs varat abonēt jebkurā laikā",
        'Monthly_discount':"Ietaupiet %@saveMoney katrs %@period! Jūs varat abonēt jebkurā laikā",
        'Ordinary_monthly_package':"Drošs, ērts un ērts veids. Jūs varat abonēt jebkurā laikā",
        "AlreadyPurchased":'Atvainojiet, ka šobrīd varat abonēt tikai vienu datu paketi. Lūdzu, abonējiet no “%@” un vēlāk abonējiet jebkuru paketi, kuru vēlaties pēc tā termiņa beigām.',
        "Contract_recommendation_First":'<label>Ar autopay servisu, par jūsu pirmo pirkumu, maksā tikai</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Jūs varat abonēt jebkurā laikā'
        +'<a class="btn">Abonēt ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Ar autopay pakalpojumu tikai maksā</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Jūs varat abonēt jebkurā laikā'
        +'<a class="btn">Abonēt ></a></p>',
        "Contract_recommendation_General":"<label>Ar autopay servisu</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Drošs, ērts un ērts veids. Jūs varat abonēt jebkurā laikā'
        +'<a href="javascript:;" class="btn">Abonēt ></a></p>',
        'BanlanceDoubleCheck':'Vai esat pārliecināts, ka vēlaties maksāt ar atlikumu?',
    },
    feedback: {
        title: "atsauksmes",
        placeholder: "Lūdzu, ievadiet valsti, kuru vēlaties apmeklēt, vai kādus citus jautājumus, un mēs pēc iespējas ātrāk apmierināsim jūsu vajadzības!",
        submit: "Iesniegt",
        submit_success: "Veiksmīgi iesniegts",
        other_opinions: "Citas viedokļi"
    },
    view_country_input: 'Lūdzu, ievadiet savu kontu',
    "select_package": {
        "title": "Izmēģiniet Datus",
        "allPackage": "Visi Dati",
        "type": "Tips",
        "flow": "Dati",
        "month_package": "Mēneša plāns",
        "flow_package": "Datu pakets",
        "time": "Ilgtspēks",
        "period": "Cikls",
        "auto_debit": "Info Autodebits",
        "auto_subscribe": "Auto-Pagarināšana",
        "detail": "Datu Detalji",
        "carrier": "Atbalstītie Operatori",
        "country": "Apklāstītās Valstis",
        "notice": "Pirkšanas rokasgrāmata"
    }
}